import { get } from 'lodash';
import { request, RequestInitWithRetry } from '../../lib/request';
import { ISortResult } from '../shared/common';

export const dataUsageDeviceTypes = ['mobile', 'wifi', 'total'] as const;
export type DataUsageDeviceType = typeof dataUsageDeviceTypes[number];

export interface IPerformanceDataUsageDeviceRow {
  id: string,
  mobile: number,
  wifi: number,
  total: number,
  serialNumber: string,
  assetTag: string,
  imei: string,
  deviceName: string,
  manufacturer: string,
  model: string,
  group: string[],
  homeLocation: { name: string } | null,
  firmware?: { version: string },
  operatingSystem?: { buildVersion: string },
  bios?: { version: string },
  updated: string
}

export interface IPerformanceDataUsageDevicesListData {
  list: IPerformanceDataUsageDeviceRow[],
  totalCount: number
}

export interface IPerformanceDataUsageDevicesFilter {
  manufacturers?: string[],
  models?: string[],
  homeLocations?: Array<string | null>,
  groups?: Array<string | null>,
  manufacturers_negate?: boolean,
  models_negate?: boolean,
  homeLocations_negate?: boolean,
  groups_negate?: boolean
}

export interface IPerformanceDataUsageDevicesOptions {
  name: DataUsageDeviceType,
  utc: number,
  timeZone: string,
  zoneId?: string | null,
  limit: number,
  offset: number,
  sort?: ISortResult,
  filter?: IPerformanceDataUsageDevicesFilter
}

const getFilterParams = (filter: IPerformanceDataUsageDevicesFilter = {}) => {
  return {
    manufacturers: filter.manufacturers || [],
    models: filter.models || [],
    homeLocations: filter.homeLocations || [],
    groups: filter.groups || [],
    ...(filter.manufacturers_negate && { manufacturers_negate: true }),
    ...(filter.models_negate && { models_negate: true }),
    ...(filter.homeLocations_negate && { homeLocations_negate: true }),
    ...(filter.groups_negate && { groups_negate: true })
  };
};

export function getCorePerformanceDataUsageDevicesList(params: IPerformanceDataUsageDevicesOptions) {
  return async (options: RequestInitWithRetry): Promise<IPerformanceDataUsageDevicesListData> => {
    const input = {
      path: '/api/core/performance/devicesDataUsage/list',
      qs: { limit: params.limit, offset: params.offset },
      body: {
        name: params.name,
        utc: params.utc,
        timeZone: params.timeZone,
        zoneId: params.zoneId,
        sort: get(params, 'sort'),
        filter: getFilterParams(params.filter)
      },
      method: 'post'
    };
    return request(input, options);
  };
}

export function exportCorePerformanceDataUsageDevicesListAction(requestOptions: RequestInitWithRetry) {
  return async (params: IPerformanceDataUsageDevicesOptions): Promise<string> => {
    const input = {
      path: '/api/core/performance/devicesDataUsage/export',
      qs: { limit: params.limit, offset: params.offset },
      body: {
        name: params.name,
        utc: params.utc,
        timeZone: params.timeZone,
        zoneId: params.zoneId,
        sort: get(params, 'sort'),
        filter: getFilterParams(params.filter)
      },
      method: 'post'
    };
    return request(input, requestOptions);
  };
}
